export default __webpack_public_path__ + "static/media/audio-1.57c248cd.mp3";